export const organizationQueryKey = 'org';
export const organizationHeader = 'X-CastAi-Organization-Id';

export const DEFAULT_VIEWER_ROLE_ID = '6fc95bd7-6049-4735-80b0-ce5ccde71cb1';
export const ENTERPRISE_VIEWER_ROLE_ID = 'd2ff8433-af9a-4a39-8900-6f6b96e43eb6';
